function openModal(modalId) {
    try {
        const modal = document.getElementById(modalId);
        if (!modal) {
            console.error(`Modal con id ${modalId} no encontrado`);
            return;
        }
        
        modal.style.display = "flex";
        document.body.classList.add("lpb-modal-open");
        
        // Disparar evento personalizado
        document.dispatchEvent(new CustomEvent('modalOpened', { 
            detail: { modalId } 
        }));
    } catch (error) {
        console.error('Error al abrir el modal:', error);
    }
}

function closeModal(event, modalId) {
    try {
        const { target } = event;
        const isModalCloseElement =
            target.classList.contains("modal") ||
            target.classList.contains("lpb-modal-close-area") ||
            target.classList.contains("lpb-modal-close") ||
            target.classList.contains("lpb-modal-close-retour") ||
            target.classList.contains("button--annule") ||
            target.classList.contains("fa-xmark");

        if (isModalCloseElement) {
            const modal = document.getElementById(modalId);
            if (!modal) {
                console.error(`Modal con id ${modalId} no encontrado`);
                return;
            }

            modal.style.display = "none";
            document.body.classList.remove("lpb-modal-open");

            // Disparar evento personalizado
            document.dispatchEvent(new CustomEvent('modalClosed', { 
                detail: { modalId } 
            }));
        }
    } catch (error) {
        console.error('Error al cerrar el modal:', error);
    }
}

function initializeSlider(sliderId) {
    const slider = document.getElementById(sliderId);
    const slides = slider.querySelectorAll(".lpb-slider__slide");
    const indicatorsContainer = document.querySelector(
        `.lpb-slider__indicators[data-slider=${sliderId}]`
    );
    const prevButton = document.querySelector(
        `.lpb-slider-button.prev[data-slider=${sliderId}]`
    );
    const nextButton = document.querySelector(
        `.lpb-slider-button.next[data-slider=${sliderId}]`
    );
    let currentIndex = 0;

    let startX = 0;
    let currentX = 0;
    let isDragging = false;

    slides.forEach((_, index) => {
        const indicator = document.createElement("div");
        indicator.classList.add("lpb-slider__indicator");
        if (index === 0) {
            indicator.classList.add("active");
        }
        indicator.addEventListener("click", () => {
            goToSlide(index);
        });
        const icon = document.createElement("i");
        icon.classList.add("fa-regular", "fa-circle");
        indicator.appendChild(icon);
        indicatorsContainer.appendChild(indicator);
    });

    function goToSlide(index) {
        slider.style.transform = `translateX(-${index * 100}%)`;
        currentIndex = index;
        updateIndicators();
        updateNavButtons();
    }

    function updateIndicators() {
        const indicators = indicatorsContainer.querySelectorAll(".lpb-slider__indicator");
        indicators.forEach((indicator, index) => {
            indicator.classList.toggle("active", index === currentIndex);
        });
    }

    function updateNavButtons() {
        prevButton.classList.toggle("hidden", currentIndex === 0);
        nextButton.classList.toggle(
            "hidden",
            currentIndex === slides.length - 1
        );
    }

    prevButton.addEventListener("click", () => {
        if (currentIndex > 0) {
            goToSlide(currentIndex - 1);
        }
    });

    nextButton.addEventListener("click", () => {
        if (currentIndex < slides.length - 1) {
            goToSlide(currentIndex + 1);
        }
    });

    slider.addEventListener("touchstart", handleTouchStart);
    slider.addEventListener("touchmove", handleTouchMove);
    slider.addEventListener("touchend", handleTouchEnd);

    function handleTouchStart(event) {
        startX = event.touches[0].clientX;
        isDragging = true;
    }

    function handleTouchMove(event) {
        if (!isDragging) return;
        currentX = event.touches[0].clientX;
        const diffX = startX - currentX;
        if (Math.abs(diffX) > 50) {
            if (diffX > 0 && currentIndex < slides.length - 1) {
                goToSlide(currentIndex + 1);
            } else if (diffX < 0 && currentIndex > 0) {
                goToSlide(currentIndex - 1);
            }
            isDragging = false;
        }
    }

    function handleTouchEnd() {
        isDragging = false;
    }

    updateNavButtons();
}